import { State } from 'src/types'
import { hamidashiOfNormal } from 'src/features/gorilla/drawer/glove/rightThrow/back/hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/gorilla/drawer/glove/rightThrow/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/gorilla/drawer/glove/rightThrow/back/ringFinger'
import { indexFingerLeft, indexFingerRight } from 'src/features/gorilla/drawer/glove/rightThrow/back/indexFinger'
import { littleFingerLeft, littleFingerRight } from 'src/features/gorilla/drawer/glove/rightThrow/back/littleFinger'
import { thumbAndListBelt, thumbOut } from 'src/features/gorilla/drawer/glove/rightThrow/back/thumbAndListBelt'
import { listBelt } from 'src/features/gorilla/drawer/glove/rightThrow/back/listBelt'
import { fingerCrotch } from 'src/features/gorilla/drawer/glove/rightThrow/back/fingerCrotch'
import { catchFace2 } from 'src/features/gorilla/drawer/glove/rightThrow/back/catchFace2'
import { edgeOfUrawaBackStyle } from 'src/features/gorilla/drawer/glove/rightThrow/back/edge/edgeOfUrawaBackStyle'
import { edgeOfWrist } from 'src/features/gorilla/drawer/glove/rightThrow/back/edge/edgeOfWrist'
import { edgeOfUrawaIndependentParts } from 'src/features/gorilla/drawer/glove/rightThrow/back/edge/edgeOfUrawaIndependentParts'
import { startInversion, thumbEmbroideryDrawerLeftThrow, undoInversion } from 'src/util/canvas'

// 通常ベルトモデル
export const higashiUrawaBackStyleDrawerLeftThrow = (
  ctx: CanvasRenderingContext2D,
  state: State,
  needCatchFaceWrap: boolean,
  canvasWidth: number
): void => {
  startInversion(ctx, canvasWidth)
  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch?.color)
  thumbOut(ctx, state.thumbOut?.color) // 親指＿外

  // 人差し指＿右... UBackここで描いてる
  indexFingerRight(ctx, state, needCatchFaceWrap)
  const isGorilla001Model = state.baseModel.productNumber === '001-20'
  const isBelt = ['normal', 'unselected', undefined].includes(state.beltType?.value) && !isGorilla001Model
  if (isBelt) listBelt(ctx, state.listBelt?.color, state.stitch?.color)

  // 人差し指＿左
  indexFingerLeft(ctx, state.indexMiddle?.color)
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.middleRing?.color)
  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左\
  ringFingerLeft(ctx, state.ringLittle?.color)

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)

  // ハミダシ
  hamidashiOfNormal(ctx, state.hamidashi?.color)
  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)

  edgeOfUrawaBackStyle(ctx, state.edge?.color, state.stitch?.color)
  const rightParts = state.littleRing
  const leftParts = state.littleOut

  edgeOfUrawaIndependentParts(ctx, leftParts.color, rightParts.color, state.edge?.color, state?.hamidashi.color, state.stitch?.color)
  edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)

  // 指股
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)

  undoInversion(ctx, canvasWidth)
  thumbEmbroideryDrawerLeftThrow(ctx, state.embroideries, state.backStyle)
  startInversion(ctx, canvasWidth)
  crossLace(ctx, state.lace?.color, -70, -585, 90)
  undoInversion(ctx, canvasWidth)
}

const crossLace = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number, numerator?: number) => {
  if (![undefined, 0].includes(numerator)) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
  }
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左側
  ctx.beginPath()
  ctx.moveTo(510 + x, 319 + y) // 左上
  ctx.quadraticCurveTo(507 + x, 352 + y, 507 + x, 352 + y) // 左下
  ctx.quadraticCurveTo(512 + x, 355 + y, 516 + x, 353 + y) // 右下下
  ctx.quadraticCurveTo(522 + x, 325 + y, 519 + x, 315 + y) // 右上
  ctx.quadraticCurveTo(512 + x, 312 + y, 510 + x, 319 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(511 + x, 319 + y) // 左上
  ctx.quadraticCurveTo(513 + x, 332 + y, 507 + x, 350 + y) // 左下
  ctx.stroke()
  ctx.closePath()

  // 右側
  ctx.beginPath()
  // ctx.strokeStyle = 'blue' // '#383838'
  ctx.moveTo(494 + x, 334 + y) // 左上
  ctx.quadraticCurveTo(494 + x, 338 + y, 496 + x, 343 + y) // 左下
  ctx.quadraticCurveTo(525 + x, 337 + y, 533 + x, 337 + y) // 右下
  ctx.quadraticCurveTo(533 + x, 333 + y, 530 + x, 328 + y) // 右上
  ctx.quadraticCurveTo(510 + x, 328 + y, 494 + x, 334 + y) // 左上
  ctx.fill()
  // // 断面ライン
  ctx.moveTo(496 + x, 343 + y) // 下
  ctx.quadraticCurveTo(521 + x, 334 + y, 533 + x, 337 + y) // 右下
  ctx.stroke()
  ctx.closePath()
  if (numerator !== undefined) {
    ctx.restore()
  }
}
